var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfterFirstWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 9,
    fill: "#FFF2EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8217 23.1267C33.8414 22.932 34.1009 22.862 34.2047 23.0279C35.8385 25.6356 37 28.2966 37 30.8965C37 36.9772 32.3795 40 28 40C23.5854 40 19 36.9422 19 31.2984C19 26.3 22.4826 23.6353 22.1607 20.071C22.1463 19.9112 22.3089 19.7904 22.4469 19.8724C23.5934 20.5545 24.4133 21.8696 24.5579 23.418C26.1594 21.1068 26.8884 17.7521 26.1872 14.4311C26.1517 14.2627 26.3245 14.1267 26.4715 14.2162C29.0624 15.7944 32.6628 20.2622 32.9475 25.2527C33.5012 24.759 33.734 23.9922 33.8217 23.1267Z",
    fill: "#F38059"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterFirstWeek);
export default __webpack_public_path__ + "static/media/After_first_week.213035d46684d4139ac8f679483deb81.svg";
export { ForwardRef as ReactComponent };